"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptAndDecrypt = void 0;
var CryptoJS = require("crypto-js");
var EncryptAndDecrypt = (function () {
    function EncryptAndDecrypt(config) {
        this.config = config;
    }
    EncryptAndDecrypt.prototype.enCryptDeCryptValue = function (value, keyData, isEncrypt) {
        var config = this.config;
        if (value) {
            var type = 'AES';
            var key = keyData;
            var iv = undefined;
            var mode = 'CBC';
            var padding = 'Pkcs7';
            if (config && config.encrypt && config.encrypt.type) {
                if (config.encrypt.type) {
                    type = config.encrypt.type;
                }
                if (config.encrypt.key) {
                    key = config.encrypt.type;
                }
                if (config.encrypt.iv) {
                    iv = CryptoJS.enc.Hex.parse(config.encrypt.iv);
                }
                if (config.encrypt.mode) {
                    mode = config.encrypt.mode;
                }
                if (config.encrypt.padding) {
                    padding = config.encrypt.padding;
                }
            }
            try {
                var enc = void 0;
                if (isEncrypt) {
                    enc = CryptoJS[type]
                        .encrypt(value, key, {
                        iv: iv,
                        mode: CryptoJS.mode[mode],
                        padding: CryptoJS.pad[padding],
                    })
                        .toString();
                }
                else {
                    enc = CryptoJS[type]
                        .decrypt(value, key, {
                        iv: iv,
                        mode: CryptoJS.mode[mode],
                        padding: CryptoJS.pad[padding],
                    })
                        .toString(CryptoJS.enc.Utf8);
                }
                return enc;
            }
            catch (error) {
                console.log('provided input is not valid!');
            }
        }
    };
    return EncryptAndDecrypt;
}());
exports.EncryptAndDecrypt = EncryptAndDecrypt;
//# sourceMappingURL=encrypt_deccrypt.js.map